import httpService from "@/services/httpService";

export default {
  addPayment: async payment => httpService.post("/payment", payment),
  loadPayments: async documentId => {
    return httpService.get("/payment", { documentId });
  },
};
